export const CONTAINER_ID = "awsccc-sb-ux-c";
export const APP_ID = "awsccc-sb-a";
export const BANNER_ID = "awsccc-cb";
export const BANNER_CUSTOMIZE_BTN_ID = "awsccc-cb-btn-customize";
export const BANNER_ACCEPT_BTN_ID = "awsccc-cb-btn-accept";
export const CUSTOMIZE_ID = "awsccc-cs";
export const CUSTOMIZE_CANCEL_BTN_ID = "awsccc-cs-btn-cancel";
export const CUSTOMIZE_SAVE_BTN_ID = "awsccc-cs-btn-save";
export const TABTRAP_ID = "awsccc-cs-tabtrap";